import service from "../utils/axios";

// 优惠券领取页允许匿名访问：后端对未登录请求返回 40201/40502 时，
// 由页面弹出登录引导，而不是被全局拦截器强制跳转登录页。
const SILENT_AUTH = { skipAuthRedirect: true };

/**
 * 优惠券详情
 * GET /wctapi/coupons/{code}
 * code 为 12 位短链码（^[A-Za-z0-9]{12}$）
 * 返回 { code, message, data: CouponDetailD }
 */
const getCouponDetail = (code) => {
  return service.get(`/coupons/${encodeURIComponent(code)}`, SILENT_AUTH);
};

/**
 * 领取优惠券
 * POST /wctapi/coupons/{code}/claim
 * 返回 { code, message, data: CouponClaimD }
 */
const claimCoupon = (code) => {
  return service.post(`/coupons/${encodeURIComponent(code)}/claim`, null, SILENT_AUTH);
};

/**
 * 我的优惠券列表
 * GET /wctapi/coupons/my?status=1|2|3&skip=0&limit=20
 * status：1-未使用 2-已使用 3-已过期（默认 1），limit 上限 100
 * 返回 { code, message, data: CouponMyListData }
 * options 可透传请求配置（如 skipAuthRedirect：未登录时不触发全局登录跳转）
 */
const getMyCoupons = (params, options) => {
  return service.get("/coupons/my", { params, ...(options || {}) });
};

/**
 * 首页弹窗优惠券
 * GET /wctapi/coupons/popup
 * 返回 { code, message, data: CouponDetailD | null }
 * 弹窗属于非关键内容：未登录(40201)/无弹窗配置时不展示，且不触发全局登录跳转
 */
const getCouponPopup = () => {
  return service.get("/coupons/popup", SILENT_AUTH);
};

/**
 * 我的优惠券数量（未使用/已使用/已过期）
 * GET /wctapi/coupons/my/count
 * 返回 { code, message, data: CouponUserCountD }
 */
const getMyCouponCount = () => {
  return service.get("/coupons/my/count");
};

export {
  getCouponDetail,
  claimCoupon,
  getCouponPopup,
  getMyCoupons,
  getMyCouponCount,
};
